const doc = [({"ja":({"consultViaPlatform":"{{platform}}で相談する", "consultViaPlatformShort":"{{platform}}で相談", "forCruiseConsultation":"クルーズ相談はこちら"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;